export default "__VITE_ASSET__Cv9ec$Mw__"